<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card p-1 pb-2">
            <div class="row">
              <div class="col-md-12" v-show="possui_fluxo">
                <div class="alert alert-warning" role="alert">
                  Atenção, não há fluxo de aprovação definido para esse centro
                  de custo!
                </div>
              </div>
              <div class="col-md-4">
                <label>Tipo de compra</label>
                <v-select v-model="dasp.purchase_type_id" :options="purchase_types"
                  :reduce="(purchase_types) => purchase_types.id" :label="'name'" disabled
                  :disabled="!isAccessNivel8"></v-select>
              </div>
              <div :class="!rateio ? 'col-md-6' : 'd-none'">
                <label>Centro de Custo</label>
                <v-select v-model="dasp.bill_center_id" :options="billCenter" :reduce="(billCenter) => billCenter.id"
                  :label="'number_name'" @input="searchBillCenter"></v-select>
              </div>
              <div :class="rateio ? 'col-md-6' : 'd-none'">
                <label>Centro de Custo</label>
                <v-select v-model="dasp.bill_center_id" :options="billCenter" :reduce="(billCenter) => billCenter.id"
                  :label="'number_name'" multiple></v-select>
              </div>
              <div class="col-md-2">
                <br />
                <div class="custom-control custom-switch">
                  <input autocomplete="new-password" v-model="rateio" placeholder="" type="checkbox"
                    class="custom-control-input" id="customSwitch2" />
                  <label class="custom-control-label" for="customSwitch2">Rateio</label>
                </div>
              </div>
              <div class="col-md-12">
                <label>Colaborador</label>
                <v-select v-model="dasp.collaborator" :options="users" :reduce="(users) => users.id" :label="'name'"
                  :disabled="!isAccessNivel8"></v-select>
              </div>
              <div class="col-md-6">
                <label>Destino desta aquisição</label>
                <v-select v-model="dasp.destination" :options="destination" :reduce="(destination) => destination.id"
                  :label="'name'" :disabled="!isAccessNivel8"></v-select>
              </div>
              <div class="col-md-6">
                <label>Valor Orçado</label>
                <input type="text" class="form-control" v-model="dasp.budget" v-money="moneyConfig" disabled />
              </div>

              <div class="col-md-12">
                <label>Observação</label>
                <textarea class="form-control" v-model="dasp.observation" rows="3"></textarea>
              </div>
              <hr />
              <div class="col-12 mt-2">
                <h4>Detalhes do produto/serviço</h4>
              </div>
              <div class="col-md-4">
                <label>Descrição</label>
                <input type="text" class="form-control" v-model="products.description" />
              </div>
              <div class="col-md-4">
                <label>Link</label>
                <input type="text" class="form-control" v-model="products.link" />
              </div>
              <div class="col-md-2">
                <label>Valor orçado</label>
                <input type="text" class="form-control" min="0" v-money="moneyConfig" v-model="products.budget" />
              </div>
              <div class="col-md-2">
                <label>Quantidade</label>
                <input type="number" class="form-control" min="1" v-model="products.quantity" required />
              </div>
              <div class="col-md-2">
                <button class="btn btn-add mt-2" @click="add">Adicionar</button>
              </div>
              <div class="col-md-12 mt-1">
                <table class="table table-bordered" style="width: 100%">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 30%">Descrição</th>
                      <th scope="col" style="width: 20%">Link</th>
                      <th scope="col" style="width: 15%">Valor Orçado</th>
                      <th scope="col" style="width: 15%">Quantidade</th>
                      <th scope="col" style="width: 10%">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(product, index) in list" :key="index">
                      <td>{{ product.description }}</td>
                      <td style="
                          max-width: 200px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                        ">
                        {{ product.link }}
                      </td>
                      <td>
                        <input type="text" class="form-control" v-money="moneyConfig" v-model="product.budget"
                          @blur="validateBudget(product, $event)" />
                      </td>
                      <td>
                        <input type="number" class="form-control" v-model="product.quantity" min="1"
                          @blur="validateQuantity(product, $event)" required />
                      </td>
                      <td>
                        <button class="btn btn-crud delete" @click="remover(index)">
                          <i class="far fa-trash-alt" data-toggle="tooltip" title="Excluir"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-md-12 text-right">
                <hr />
                <router-link to="/dasps" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left" />
                  Voltar
                </router-link>
                <a class="btn btn-add" @click="save">
                  Abrir Solicitação
                  <i class="fa fa-save" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      rateio: 0,
      possui_fluxo: false,
      moneyConfig: {
        prefix: "R$ ",
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      dasp: {},
      billCenter: [],
      users: [],
      products: [],
      list: [],
      purchase_types: [],
      type: [
        {
          id: 1,
          name: "Serviços",
        },
        {
          id: 2,
          name: "Equipamentos e Materiais",
        },
      ],
      destination: [
        {
          id: 1,
          name: "Patrimônio IT4D",
        },
        {
          id: 2,
          name: "Para o cliente previsto no contrato de fornecimento",
        },
        {
          id: 3,
          name: "Consumo",
        },
        {
          id: 4,
          name: "Revenda",
        },
      ],
      agreement: [
        {
          id: 1,
          name: "Apenas Pedido de Compra",
        },
        {
          id: 2,
          name: "Fornecimento Recorrente",
        },
      ],
      term: [
        {
          id: 1,
          name: "Imediato",
        },
        {
          id: 2,
          name: "Muito urgente",
        },
        {
          id: 3,
          name: "Urgente",
        },
        {
          id: 4,
          name: "Não urgente",
        },
      ],
      payment: [
        {
          id: 1,
          name: "Cartão de Crédito",
          active: true,
        },
        {
          id: 2,
          name: "Boleto",
          active: false,
        },
        {
          id: 3,
          name: "Pix",
          active: false,
        },
      ],
    };
  },
  computed: {
    isAccessNivel8() {
      return this.$store.state.user.perfil_id === 8;
    },
  },
  methods: {
    makeFormData: function () {
      const self = this;
      let fd = new FormData();
      fd.append("term", self.dasp.term ? self.dasp.term : "");
      fd.append(
        "bill_center_id",
        self.dasp.bill_center_id ? self.dasp.bill_center_id : ""
      );
      fd.append(
        "destination",
        self.dasp.destination ? self.dasp.destination : ""
      );
      fd.append("agreement", self.dasp.agreement ? self.dasp.agreement : "");
      fd.append(
        "purchase_type_id",
        self.dasp.purchase_type_id ? self.dasp.purchase_type_id : ""
      );
      fd.append(
        "collaborator",
        self.dasp.collaborator ? self.dasp.collaborator : ""
      );
      fd.append("observation", self.dasp.observation ? self.dasp.observation : "");

      // Padronizar a estrutura dos produtos antes de enviar
      const cleanedList = self.list.map(product => ({
        description: product.description || product.name || "",
        link: product.link || "Não informado",
        quantity: product.quantity || product.quantity_requested || 1,
        budget: product.budget || "R$ 0,00"
      }));

      fd.append("list", JSON.stringify(cleanedList));

      return fd;
    },
    save: function () {
      const self = this;
      let api = self.$store.state.api + "dasps";

      if (!self.list.length) {
        this.$message(
          null,
          "Você precisa adicionar produtos/serviços",
          "error"
        );
        return;
      }

      // Validar se há produtos com quantidade ou valor orçado inválidos
      const invalidProducts = self.list.filter(product => {
        const quantity = Number(product.quantity) || 0;
        const budgetValue = String(product.budget || "")
          .replace(/[R$\s]/g, "")
          .replace(/\./g, "")
          .replace(",", ".");
        const budgetNumber = parseFloat(budgetValue) || 0;

        return quantity <= 0 || budgetNumber <= 0;
      });

      if (invalidProducts.length > 0) {
        this.$message(
          null,
          "Existem produtos com quantidade ou valor orçado igual a zero. Por favor, corrija antes de abrir a solicitação.",
          "error"
        );
        return;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/dasps");
        })
        .catch((error) => {
          console.error("Erro ao salvar DASP:", error);

          let errorMessage = "Erro ao salvar a DASP";

          if (error.response) {
            // Erro com resposta do servidor
            if (error.response.data) {
              errorMessage = error.response.data.message || error.response.data || "Erro interno do servidor";
            }
            console.error("Dados do erro:", error.response.data);
            console.error("Status:", error.response.status);
          } else if (error.request) {
            // Erro de rede
            errorMessage = "Erro de conexão com o servidor";
          }

          self.$message(null, errorMessage, "error");
        });
    },
    getDasp: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasps/" + id;

      return axios
        .get(api)
        .then((response) => {
          self.dasp = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getPurchaseTypes: function () {
      const self = this;
      const api = self.$store.state.api + "purchase_types?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.purchase_types = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBillCenter: function () {
      const self = this;
      const api = self.$store.state.api + "bill_centers?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.billCenter = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      const api = self.$store.state.api + "users_solicitation?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.users;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    formatarData(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    add() {
      if (this.products.description === "") {
        this.$message(null, "Você precisa informar a descrição", "error");
        return;
      }

      // Validação mais robusta para quantidade
      if (this.products.quantity === "" || this.products.quantity === null || this.products.quantity === undefined) {
        this.$message(null, "Você precisa informar a quantidade", "error");
        return;
      }

      // Validação para não permitir quantidade 0 ou negativa
      const quantityValue = Number(this.products.quantity);
      if (isNaN(quantityValue) || quantityValue <= 0) {
        this.$message(null, "A quantidade deve ser maior que zero", "error");
        return;
      }

      // Validação para não permitir valor orçado 0
      const budgetValue = String(this.products.budget || "")
        .replace(/[R$\s]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const budgetNumber = parseFloat(budgetValue);

      if (!this.products.budget || isNaN(budgetNumber) || budgetNumber <= 0) {
        this.$message(null, "O valor orçado deve ser maior que zero", "error");
        return;
      }

      // if (this.products.link !== "" && !(["http://", "https:/"].includes(this.products.link.substring(0, 7)))) {
      //   this.$message(null, "Por favor, insira um link válido (http, ou https)", "error");
      //   return;
      // }

      const newEntry = {
        description: this.products.description,
        link: this.products.link,
        quantity: this.products.quantity,
        budget: this.products.budget,
      };

      this.list.push(newEntry);

      this.products.description = "";
      this.products.link = "";
      this.products.quantity = "";
      this.products.budget = "";

      this.changeBudget();
    },
    remover(index) {
      const self = this;
      self.list.splice(index, 1);

      this.changeBudget();
    },

    validateQuantity(product, event) {
      const value = event.target.value;
      const numericValue = Number(value);

      // Verificar se é vazio, null, undefined, NaN ou <= 0
      if (value === "" || value === null || isNaN(numericValue) || numericValue <= 0) {
        this.$message(null, "A quantidade deve ser maior que zero", "error");
        product.quantity = 1; // Reset para valor padrão válido
        event.target.value = 1;
        // Forçar atualização do v-model
        this.$nextTick(() => {
          product.quantity = 1;
        });
      }
      this.changeBudget();
    },

    validateBudget(product, event) {
      const budgetValue = String(event.target.value || "")
        .replace(/[R$\s]/g, "")
        .replace(/\./g, "")
        .replace(",", ".");
      const budgetNumber = parseFloat(budgetValue);

      if (isNaN(budgetNumber) || budgetNumber <= 0) {
        this.$message(null, "O valor orçado deve ser maior que zero", "error");
        product.budget = "R$ 1,00"; // Reset para valor padrão válido
      }
      this.changeBudget();
    },

    changeBudget() {
      const self = this;

      self.dasp.budget = 0;


      self.list.forEach((product) => {
        const unit = parseFloat(
          String(product.budget || "")
            .slice(3)                 // remove "R$ "
            .replace(/\./g, "")
            .replace(/,/g, ".")
        ) || 0;

        // use a quantidade (padrão = 1)
        const qty = Number(product.quantity) || 1;


        self.dasp.budget += unit;
      });

      self.dasp.budget = Math.round(self.dasp.budget * 10000) / 100;

    },
    getDaspProducts: function (id) {
      const self = this;
      const api = self.$store.state.api + "dasp_products?dasp_id=" + id;

      axios
        .get(api)
        .then((response) => {
          self.list = response.data.data;

          self.list.forEach((item) => {
            item.description = item.name;
            item.quantity = item.quantity_requested || '';
          });

          self.changeBudget();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    searchBillCenter() {
      const self = this;
      let api =
        self.$store.state.api +
        `bill_center_flows?bill_center_id=${self.dasp.bill_center_id}`;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.possui_fluxo = response.data.data.length === 0 ? true : false;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.getBillCenter();
    self.getUsers();
    self.getPurchaseTypes();

    if (id) {
      // Carrega primeiro os dados da DASP, depois os produtos
      self.getDasp(id).then(() => {
        self.getDaspProducts(id);
      });
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>